<template>
  <!-- Generator: Adobe Illustrator 26.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
  <svg
    id="Layer_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 438.54 193.53"
    style="enable-background: new 0 0 438.54 193.53"
    xml:space="preserve"
    width="24"
    height="24"
  >
    <g>
      <polygon
        class="st0"
        points="166.53,149.92 195.41,149.92 213.51,43.87 184.59,43.87 "
      />
      <path
        class="st0"
        d="M271.8,86.46c-10.11-4.91-16.3-8.18-16.24-13.15c0-4.41,5.24-9.12,16.56-9.12c9.45-0.15,16.3,1.91,21.62,4.06
        l2.6,1.23l3.91-22.99c-5.73-2.15-14.7-4.46-25.91-4.46c-28.56,0-48.68,14.38-48.86,35c-0.16,15.24,14.36,23.74,25.33,28.81
        c11.26,5.2,15.04,8.52,14.99,13.16c-0.08,7.11-8.99,10.35-17.31,10.35c-11.56,0-17.71-1.6-27.2-5.56l-3.72-1.68l-4.06,23.74
        c6.74,2.96,19.23,5.52,32.2,5.65c30.39,0,50.11-14.21,50.33-36.24C296.17,103.21,288.48,94.03,271.8,86.46z"
      />
      <path
        class="st0"
        d="M374.39,43.97h-22.33c-6.92,0-12.1,1.89-15.14,8.8l-42.92,97.19h30.36c0,0,4.95-13.07,6.08-15.94
        c3.32,0,32.8,0.05,37.02,0.05c0.86,3.71,3.51,15.89,3.51,15.89h26.83L374.39,43.97z M338.74,112.34
        c2.39-6.11,11.51-29.65,11.51-29.65c-0.16,0.28,2.38-6.14,3.83-10.12l1.96,9.15c0,0,5.53,25.32,6.7,30.63H338.74z"
      />
      <path
        class="st0"
        d="M142.28,43.95l-28.3,72.32l-3.02-14.69l-10.12-48.74c-1.75-6.72-6.83-8.72-13.1-8.95H41.1l-0.36,2.2
        c11.34,2.75,21.47,6.71,30.36,11.63l25.7,92.12l30.58-0.04L172.9,43.95H142.28z"
      />
    </g>
  </svg>
</template>
